import { fetchDiscovered } from "./discovered";
import { fetchRequestsWithName } from "./requestsWithName";

export const fetchNewDevices = () => async (dispatch) => {
  await dispatch(fetchDiscovered());
  await dispatch(fetchRequestsWithName());
};
